import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    switches: [
      {
        id: "85dc9562-58d3-8738-9735-ca2139a83819",
        deviceName: "AA:BB:CC:DD:EE:01",
        modelName: "DGS-1210-28",
        port: 1,
        status: {
          adminState: 1,
          status: 3,
          isUplink: 1,
          speed: 9,
          mediaType: 1,
          duplex: 2,
          errorState: "00",
          poe: { status: 0, classifications: 0 },
        },
        speed: "10Gbps",
        portType: "Access",
        pvid: 10,
        allowedVlans: [],
        poe: "Enabled",
        tags: [],
        portName: "D-Link Switch",
      },
      {
        id: "aks0312f-58d3-8738-9735-ca2139a83819",
        deviceName: "FE:DC:BA:98:76:54",
        modelName: "DGS-1210-28",
        port: 2,
        status: {
          adminState: 1,
          status: 1,
          isUplink: 1,
          speed: 4,
          mediaType: 2,
          duplex: 2,
          errorState: "00",
          poe: { status: 3, classifications: 5 },
        },
        speed: "1Gbps",
        portType: "Access",
        pvid: 19,
        allowedVlans: [],
        poe: "Disabled",
        tags: ["209133", "ddddd"],
        portName: "D-Link 2F Switch",
      },
      {
        id: "85dc9562-ef3f-8738-9735-ca2139a83819",
        deviceName: "AA:BB:CC:DD:EE:02",
        modelName: "DGS-1210-26",
        port: 3,
        status: {
          adminState: 1,
          status: 3,
          isUplink: 0,
          speed: 7,
          mediaType: 1,
          duplex: 1,
          errorState: "00",
          poe: { status: 3, classifications: 1 },
        },
        speed: "2.5Gbps",
        portType: "Trunk",
        pvid: 200,
        allowedVlans: [100, 110, 120, 130],
        poe: "Disabled",
        tags: ["good"],
        portName: "D-Link 3F Switch",
      },
    ],
    accessPoints: [
      {
        id: "85dc9562-58d3-8738-9735-ca2139a83819",
        deviceName: "AA:BB:CC:DD:EE:01",
        modelName: "DGS-1210-28",
        port: 1,
        status: {
          adminState: 1,
          status: 3,
          isUplink: 1,
          speed: 9,
          mediaType: 1,
          duplex: 2,
          errorState: "00",
          poe: { status: 0, classifications: 0 },
        },
        pvid: 10,
        allowedVlans: [],
        tags: ["Alice"],
      },
      {
        id: "aks0312f-58d3-8738-9735-ca2139a83819",
        deviceName: "FE:DC:BA:22:70:54",
        modelName: "DGS-1210-29",
        port: 2,
        status: {
          adminState: 1,
          status: 3,
          isUplink: 0,
          speed: 7,
          mediaType: 1,
          duplex: 1,
          errorState: "00",
          poe: { status: 3, classifications: 1 },
        },
        pvid: 19,
        allowedVlans: [],
        tags: [],
      },
      {
        id: "85dc9562-ef3f-8738-9735-ca2139a83819",
        deviceName: "FE:DC:BA:98:76:54",
        modelName: "DGS-1210-28",
        port: 3,
        status: {
          adminState: 1,
          status: 1,
          isUplink: 1,
          speed: 4,
          mediaType: 2,
          duplex: 2,
          errorState: "00",
          poe: { status: 3, classifications: 5 },
        },
        pvid: 200,
        allowedVlans: [100, 110, 120, 130],
        tags: ["Bob"],
      },
    ],
  },
};

export const wiredSlice = createSlice({
  name: "wired",
  initialState,
  reducers: {
    setWiredSwitchesData: (state, action) => {
      state.switches.data = action.payload;
    },
    setWiredAccessPointsData: (state, action) => {
      state.accessPoints.data = action.payload;
    },
  },
});

export const { setWiredSwitchesData, setWiredAccessPointsData } =
  wiredSlice.actions;

export default wiredSlice.reducer;
